import React from "react";
import PropTypes from "prop-types";

export const SecondaryButton = ({
  children,
  onClick,
  disabled = false,
  className = "",
  ...props
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        bg-white border border-gray-300 text-gray-700 hover:bg-gray-50
        disabled:opacity-50 disabled:cursor-not-allowed rounded
        cursor-pointer transition-all duration-200
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

SecondaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

SecondaryButton.defaultProps = {
  onClick: null,
  disabled: false,
  className: "",
};

